import React from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';

const FiltersPartial = (props) => {
  const { filtersModel, setFiltersModel } = props;

  const onStatusAdded = (selectedItems, selectedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, status: [...(prevState.status || []), selectedOption.id] }
    })
  }

  const onStatusRemove = (selectedItems, removedOption) => {
    setFiltersModel((prevState) => {
      return { ...prevState, status: prevState.status.filter((id) => id !== removedOption.id) }
    })
  }

  return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
    <Form.Group className="mb-3">
      <Form.Label>Status</Form.Label>
      <MultiSelectField
        options={[
          {
            id: 'requested',
            name: 'Requested'
          },
          {
            id: 'finalized',
            name: 'Finalized'
          },
          {
            id: 'cancelled',
            name: 'Cancelled'
          },
          {
            id: 'completed',
            name: 'Completed'
          },
          {
            id: 'pipeline',
            name: 'Pipeline'
          },
        ]}
        fieldName="status"
        stateModel={filtersModel}
        labelAttr="name"
        valueAttr="id"
        displayValue="name"
        onSelect={onStatusAdded}
        onRemove={onStatusRemove}
      />
    </Form.Group>
  </Filters>
};

export default FiltersPartial;

